import * as calculatedFieldsActions from '../actions/students-actions/calculated-fields-action';

export interface ICalculatedFields {
  loading: boolean;
  loaded: boolean;
  calculatedFieldsEntities: object;
}

export const initialState: ICalculatedFields = {
  loading: false,
  loaded: false,
  calculatedFieldsEntities: {},
};

export function reducer(state: ICalculatedFields = initialState, action): ICalculatedFields {
  switch (action.type) {
    case calculatedFieldsActions.LOAD_POSTSECONDARY_CALCUALTED_FIELDS: {
      return { ...state, loading: true };
    }

    case calculatedFieldsActions.LOAD_POSTSECONDARY_CALCULATED_FIELDS_SUCCESS: {
      const studentList = action.payload;
      const calculatedFields = studentList.data.CalculatedFields;
      const calculatedFieldsEntities = calculatedFields.reduce((acc, element) => {
        acc[element._id] = element;
        return acc;
      }, {});
      return {
        ...state,
        loading: false,
        loaded: true,
        calculatedFieldsEntities,
      };
    }
    case calculatedFieldsActions.LOAD_POSTSECONDARY_CALCULATED_FIELDS_FAIL: {
      return {
        ...state,
        loading: false,
        loaded: false,
      };
    }

    case calculatedFieldsActions.UPDATE_POSTSECONDARY_STUDENTS_CALCULATED_FIELDS_SUCCESS: {
      const updatedCalculatedField = action.payload;
      const updatedStudentEntityId = updatedCalculatedField._id;
      const calculatedFieldsEntities = Object.assign({}, state.calculatedFieldsEntities);
      calculatedFieldsEntities[updatedStudentEntityId] = Object.assign(
        calculatedFieldsEntities[updatedStudentEntityId] || {},
        updatedCalculatedField,
      );

      return {
        ...state,
        calculatedFieldsEntities,
      };
    }
    default:
      return state;
  }
}
